// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__1vgmW","icon":"search_icon__qCCrc","input":"search_input__35aO7","button":"search_button__3pXXY"};